import React, { useEffect } from 'react';
import { toArray, filter, orderBy, pick } from 'lodash';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { VehicleModel, buildStylesPath } from 'client/data/models/vehicle';
import { Select } from 'site-modules/shared/components/select/select';
import { StyledSelect, StyledSelectPropTypes } from 'site-modules/shared/components/styled-select/styled-select';
import { connect } from 'react-redux';
import { DEFAULT_CLASSNAMES } from './constants';

export const sortById = (data, styleIds) => {
  const ids = styleIds.split(',').map(id => parseInt(id, 10));
  return filter(data, style => ids.includes(style.id));
};

export const withSortedByStyleIds = WrappedComponent => props => {
  const { onChange, options, styleIds, updateValueOnChanges } = props;

  useEffect(() => {
    if (styleIds && updateValueOnChanges) {
      const sortedOptions = sortById(options, styleIds);
      onChange(sortedOptions[0]);
    }
  }, [styleIds, updateValueOnChanges, options, onChange]);

  return <WrappedComponent {...pick(props, Object.keys(StyledSelectPropTypes))} />;
};

export const mapStateToProps = (state, props) => {
  const { options = [], value, styleIds } = props;
  if (!styleIds) {
    return {};
  }
  const sortedOptions = sortById(options, styleIds);
  let selectedValue = '';
  let updateValueOnChanges = false;

  if (sortedOptions.length === 1 && !value) {
    selectedValue = sortedOptions[0].slug;
    updateValueOnChanges = true;
  } else if (options.some(opt => opt.slug === value)) {
    selectedValue = value;
  }

  return {
    value: selectedValue,
    options: sortedOptions.length > 1 ? sortedOptions : options,
    updateValueOnChanges,
  };
};

const stateToPropsConfig = {
  options: bindToPath(
    props => {
      const { make, model, submodel, year } = props;
      let path = null;

      if (make && model && submodel && year) {
        path = buildStylesPath({ make: make.slug, model: model.slug, submodel: submodel.slug, year: year.year });
      } else if (make && model && year) {
        path = buildStylesPath({ make: make.slug, model: model.slug, year: year.year });
      }

      return path;
    },
    VehicleModel,
    trimData => orderBy(toArray(trimData), 'name')
  ),
};

export const StyleDropdown = connectToModel(Select, stateToPropsConfig);

export const StyledStyleDropdown = connectToModel(StyledSelect, stateToPropsConfig);

export const StyleDropdownWithSortedStyleId = connectToModel(
  connect(mapStateToProps)(connectToModel(withSortedByStyleIds(Select), {})),
  stateToPropsConfig
);

export const StyledStyleDropdownWithSortedStyleId = connectToModel(
  connect(mapStateToProps)(connectToModel(withSortedByStyleIds(StyledSelect), {})),
  stateToPropsConfig
);

const DEFAULT_PROPS = {
  name: 'select-style',
  toggle: 'Select Style',
  valueKey: 'slug',
  labelKey: 'name',
};

StyleDropdown.defaultProps = {
  ...DEFAULT_PROPS,
  className: `js-style-select ${DEFAULT_CLASSNAMES}`,
};

StyledStyleDropdown.defaultProps = {
  ...DEFAULT_PROPS,
};

StyleDropdownWithSortedStyleId.defaultProps = {
  ...DEFAULT_PROPS,
  className: `js-style-select ${DEFAULT_CLASSNAMES}`,
};

StyledStyleDropdownWithSortedStyleId.defaultProps = {
  ...DEFAULT_PROPS,
  className: `js-style-select ${DEFAULT_CLASSNAMES}`,
};
